import client from '../api/client.js'

const resolveOrgId = (orgId) => {
  if (!orgId) throw new Error('Missing activeOrgId')
  return orgId
}

const orgConfig = (orgId) => ({
  headers: {
    'X-Org-Id': String(resolveOrgId(orgId)),
  },
})

export const fetchTicketHistoryRequest = async (lotteryId, orgId) => {
  const response = await client.get(`/lotteries/${lotteryId}/tickets/history`, orgConfig(orgId))
  return response?.data
}

export const runTicketOperationRequest = async (lotteryId, payload, orgId) => {
  const response = await client.post(`/lotteries/${lotteryId}/tickets/operations`, payload, orgConfig(orgId))
  return response?.data
}

